import Image from 'next/image';
import styles from './SnapShotProjects.module.css';
import { IvrProducts } from '@/interfaces';
import { useState } from 'react';
type props = {
    dubaiVrProjects: IvrProducts
}
export function SnapShotProjects({ dubaiVrProjects }: props) {
    const [popUpUrl, setPopUpUrl] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const handleClick = (vrUrl: string) => {
        setPopUpUrl(vrUrl);
        setShowPopup(true);
    }
    if (!dubaiVrProjects || !dubaiVrProjects.urls || dubaiVrProjects.urls.length === 0) return;
    return (
        <section className="section bgLigtgray">
            {
                showPopup &&
                <div className={styles.popUp}>
                    <iframe src={popUpUrl} />
                    <div className={styles.closeBtn} onClick={() => { setShowPopup(false), setPopUpUrl("") }}>close</div>
                </div>
            }
            <div className="containerFull">
                <h2 className="font26 f500 text000 mb20 textCenter fontSM20">A  <span className="textpink">360-Degree</span> Snapshot of Our Interior Projects in Dubai
                </h2>
                <span className={`font16 comPletmainbox textCenter displayBlock`}>Check here how we make dreams into reality.</span>
                <div className={styles.vrMainbigbox}>
                    {
                        dubaiVrProjects.urls.slice(0, 2).map((f, idx) =>
                            <div className={styles.vrmaibigTiles} key={idx} onClick={() => handleClick(f.project3DUrl)}>
                                <figure><Image width={648} height={400} src={f.project3DThumbnail} alt={f.projectFullText} /></figure>
                                <div className={styles.vrBoxuperimg}>
                                    <Image width={55} height={36} src="/assets/images/VRlogo.svg" alt="VRlogo" />
                                </div>
                                <div className={styles.vrbigLtextbox}>
                                    <span className="font16 textfff f500 fontSM14">{f.projectName}</span>
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className={styles.vrMainsmallbx}>
                    {
                        dubaiVrProjects.urls.slice(2, 5).map((f, idx) =>
                            <div className={styles.vrmaibigTiles} key={idx} onClick={() => handleClick(f.project3DUrl)}>
                                <figure><Image width={424} height={280} src={f.project3DThumbnail} alt={f.projectName} /></figure>
                                <div className={styles.vrBoxuperimg}>
                                    <Image width={55} height={36} src="/assets/images/VRlogo.svg" alt="VRlogo" />
                                </div>
                                <div className={styles.vrbigLtextbox}>
                                    <span className="font16 textfff f500 fontSM14">{f.projectName}</span>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </section >
    )
}